/**
 * Click observer — event delegation for click triggers.
 * Uses document-level listener, no MutationObserver needed.
 * Fires once per trigger ID.
 */

import type { EventMessage } from "../messages";

type OnEvent = (msg: EventMessage) => void;

interface ClickTriggerDef {
  id: string;
  selector: string;
}

export function setupClickObservers(
  triggers: ClickTriggerDef[],
  onEvent: OnEvent,
): () => void {
  const fired = new Set<string>();

  function handler(e: MouseEvent) {
    const target = e.target as Element | null;
    if (!target) return;

    for (const trigger of triggers) {
      if (fired.has(trigger.id)) continue;
      if (target.closest(trigger.selector)) {
        fired.add(trigger.id);
        onEvent({
          type: "event",
          event: "click_trigger",
          triggerId: trigger.id,
          selector: trigger.selector,
          url: window.location.href,
        });
      }
    }
  }

  document.addEventListener("click", handler, true);

  return () => {
    document.removeEventListener("click", handler, true);
  };
}
